import React from 'react';
import { Link } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { ArrowRightIcon } from 'lucide-react';
import { SoftCard } from '../components';
export const SubmissionByInterface = ({ interfaceDataWithColors, CustomTooltip }) => {
    return (React.createElement(SoftCard, { header: {
            title: "Submissions by Interface Type",
            subtitle: "Form layouts users are interacting with"
        }, footer: {
            children: (React.createElement("div", { className: "flex justify-between items-center" },
                React.createElement("div", { className: "flex space-x-4" }, interfaceDataWithColors.map((item, index) => (React.createElement("div", { key: index, className: "flex items-center text-sm text-gray-600" },
                    React.createElement("div", { className: "w-4 h-4 rounded mr-1", style: { backgroundColor: item.color } }),
                    React.createElement("span", null, item.name))))),
                React.createElement(Link, { to: "/submissions", className: "text-sm font-medium text-orange-500 hover:text-orange-600 flex items-center" },
                    "View Details",
                    React.createElement(ArrowRightIcon, { className: "w-4 h-4 ml-1" }))))
        } },
        React.createElement("div", { className: "h-64" },
            React.createElement(ResponsiveContainer, { width: "100%", height: "100%" },
                React.createElement(BarChart, { data: interfaceDataWithColors, margin: {
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 5
                    }, barSize: 40 },
                    React.createElement(CartesianGrid, { strokeDasharray: "3 3", vertical: false }),
                    React.createElement(XAxis, { dataKey: "name" }),
                    React.createElement(YAxis, null),
                    React.createElement(Tooltip, { content: React.createElement(CustomTooltip, { active: false, payload: [], label: "" }) }),
                    React.createElement(Bar, { dataKey: "value", name: "Submissions", radius: [4, 4, 0, 0] }, interfaceDataWithColors.map((entry, index) => React.createElement(Cell, { key: `cell-${index}`, fill: entry.color }))))))));
};
export default SubmissionByInterface;
